var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMissingDevice = function SvgMissingDevice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Missing Device",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 30.58595 0 30.58595 30.5858 0 30.5858"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3334,5.6663 C4.3334,4.9303 4.9304,4.3333 5.6664,4.3333 L22.8384,4.3333 L25.3564,1.8153 C25.0284,1.7273 24.6894,1.6663 24.3334,1.6663 L5.6664,1.6663 C3.4574,1.6663 1.6664,3.4573 1.6664,5.6663 L1.6664,24.3333 C1.6664,24.6893 1.7284,25.0283 1.8154,25.3563 L4.3334,22.8383 L4.3334,5.6663 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6667,13.6663 L9.6667,9.6663 L17.5057,9.6663 L20.1717,6.9993 L9.6667,6.9993 C8.1937,6.9993 6.9997,8.1933 6.9997,9.6663 L6.9997,13.6663 C6.9997,15.1393 8.1937,16.3333 9.6667,16.3333 L10.8387,16.3333 L13.5057,13.6663 L9.6667,13.6663 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,20.333 L17.667,20.333 C16.93,20.333 16.333,20.93 16.333,21.666 C16.333,22.403 16.93,23 17.667,23 L19,23 C19.736,23 20.333,22.403 20.333,21.666 C20.333,20.93 19.736,20.333 19,20.333",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.6669,
    y1: 16.333,
    x2: 18.3339,
    y2: 13.666,
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6667,24.333 C25.6667,25.069 25.0697,25.666 24.3337,25.666 L6.3337,25.666 L9.7887,22.211 C9.9977,22.674 10.4587,23 10.9997,23 L12.3337,23 C13.0697,23 13.6667,22.403 13.6667,21.666 C13.6667,20.93 13.0697,20.333 12.3337,20.333 L11.6667,20.333 L15.6667,16.333 L20.3337,16.333 C21.8057,16.333 22.9997,15.139 22.9997,13.666 L22.9997,9.666 C22.9997,9.461 22.9717,9.264 22.9277,9.072 L25.6667,6.333 L25.6667,24.333 Z M20.3337,11.666 L20.3337,13.666 L18.3337,13.666 L20.3337,11.666 Z M30.2927,0.293 C30.0977,0.098 29.8417,0 29.5857,0 C29.3297,0 29.0747,0.098 28.8787,0.293 L26.7077,2.464 L24.7537,4.418 L21.7547,7.417 L19.5057,9.666 L15.5057,13.666 L12.8387,16.333 L4.4187,24.753 L2.4637,26.708 L0.2927,28.879 C0.0977,29.074 -0.0003,29.33 -0.0003,29.586 C-0.0003,29.842 0.0977,30.098 0.2927,30.293 C0.4887,30.488 0.7437,30.586 0.9997,30.586 C1.2557,30.586 1.5117,30.488 1.7067,30.293 L4.0267,27.973 C4.5277,28.2 5.0807,28.333 5.6667,28.333 L24.3337,28.333 C26.5427,28.333 28.3337,26.542 28.3337,24.333 L28.3337,5.666 C28.3337,5.08 28.2007,4.528 27.9737,4.026 L30.2927,1.707 C30.6837,1.316 30.6837,0.683 30.2927,0.293 L30.2927,0.293 Z",
    id: "Fill-9",
    mask: "url(#mask-2)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMissingDevice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "missing-device.1fb82d784255105b7e67d4b2ecac5c3e.svg";